export function countUp() {
    function bty_countUp() {

        function bty_animateValue(obj, start, end, duration) {
            let startTimestamp = null;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                obj.innerHTML = Math.floor(progress * (end - start) + start);
                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        let objs = document.querySelectorAll('.template-agency__left-two_counter-one');

        let i;
        for (i = 0; i < objs.length; i++) {
            let object = objs[i];

            document.addEventListener('scroll', function () {
                let inView = object.getBoundingClientRect();
                if (inView.top >= 0 && inView.bottom <= (window.innerHeight || document.documentElement.clientHeight) && !object.classList.contains('counted')) {
                    bty_animateValue(object, 0, parseInt(object.innerHTML), 2500);
                    object.classList.add('counted');
                }
            });
        }
    }

    document.addEventListener('DOMContentLoaded', function () {
        bty_countUp();
    });
};
